<template>
  <i-tooltip class="legend-convert" placement="bottom-end" theme="light">
    <i-icon size="20" type="ios-help-circle" />
    <div slot="content">
      <h2 class="content-title">ボタンの状態</h2>
      <ul class="list-sample_conv">
        <li class="list-sample_conv__item">
          <i-button class="btn-convert not_posted" size="small">未掲載</i-button>
        </li>
        <li class="list-sample_conv__item">
          <i-button class="btn-convert sending_reservation" size="small">送信予約</i-button>
        </li>
        <li class="list-sample_conv__item">
          <i-button class="btn-convert sending" size="small">送信中</i-button>
        </li>
        <li class="list-sample_conv__item">
          <i-button class="btn-convert sent" size="small">掲載中</i-button>
        </li>
        <li class="list-sample_conv__item">
          <i-button class="btn-convert deleting_reservation" size="small">削除予約</i-button>
        </li>
        <li class="list-sample_conv__item">
          <i-button class="btn-convert deleting" size="small">削除処理中</i-button>
        </li>
        <li class="list-sample_conv__item">
          <i-button class="btn-convert deleted" size="small">削除済み</i-button>
        </li>
        <li class="list-sample_conv__item">
          <i-button class="btn-convert due_today" size="small">期限本日</i-button>
        </li>
        <li class="list-sample_conv__item">
          <i-button class="btn-convert expired" size="small">期限切れ</i-button>
        </li>
        <li class="list-sample_conv__item">
          <i-button class="btn-convert error" size="small">エラー</i-button>
        </li>
      </ul>
    </div>
  </i-tooltip>
</template>

<script>
import { Tooltip, Icon, Button } from 'view-design'

export default {
  components: {
    'i-tooltip': Tooltip,
    'i-icon': Icon,
    'i-button': Button,
  },
}
</script>

<style lang="scss" scoped>
.legend-convert {
  .list-sample_conv {
    list-style: none;
    &__item {
      text-align: center;
      margin-bottom: 8px;
    }
  }
}
</style>
